import HostVmOptionInfo from './HostVmOptionInfo';

export default class HostInfo {
  computerName: string;
  coresCount: number;
  cpuName: string;
  curCultureEngName: string;
  curCultureName: string;
  curUICultureEngName: string;
  curUICultureName: string;
  domainName: string;
  frameworkVersion: string;
  gpuName: string;
  lastBoot: string;
  logicalProcessorsCount: number;
  network: { ip4Address: string };
  osName: string;
  osType: string;
  physicalProcessorsCount: number;
  systemUptime: string;
  temperatureInfos: [{ currentTemperature: number; instanceName: string }];
  timeZone: string;
  totalPhysicalMemory: string;
  totalVirtualMemory: string;
  userDomainName: string;
  userName: string;
  utcOffsetInMinutes: number;
  version: string;
  vm: HostVmOptionInfo;
  x64: boolean;
  serialNumber: string;
  systemType: string;
  manufactured: string;
  model: string;
  lastLogin: string;
  productType: string;
  location?: string;
  message: string;
  status: string;
  success: boolean;
  operationSystemID?: string;
  computerState?: ComputerState;
}

export interface LocationInfo {
  ip: string;
  continentCode: string;
  continentName: string;
  country: string;
  city: string;
  timeZone: string;
  countryIsoCode: string;
  subdivision1IsoCode: string;
  subdivision1Name: string;
  postalCode: string;
}

export interface HostInfoMemory {
  hardwarePhysicalMemorySize: number;
  hardwareVirtualMemorySize: number;
  freePhysicalMemoryKb: number;
}

export enum ComputerState {
  Unknown = 0,
  NoActiveUserSession = 1,
  ScreenIsLocked = 2,
  ScreenIsActive = 3
}
